<template>
  <div class="shape">
    <div ref="mapContainer" class="shape"></div>
    <div id="county-legend" class="legend">
      <h4>PM<sub>25</sub></h4>
      <div><span style="background-color: #d7191c"></span>170</div>
      <div><span style="background-color: #e85b3a"></span>46.5</div>
      <div><span style="background-color: #f99e59"></span>30.9</div>
      <div><span style="background-color: #fec980"></span>21.4</div>
      <div><span style="background-color: #ffedaa"></span>14.3</div>
      <div><span style="background-color: #edf8b9"></span>9.3</div>
      <div><span style="background-color: #c7e9ad"></span>6.8</div>
      <div><span style="background-color: #9dd3a7"></span>5.1</div>
      <div><span style="background-color: #64abb0"></span>3.5</div>
      <div><span style="background-color: #2b83ba"></span>1.1</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import mapboxgl from 'mapbox-gl';

//Normally this is in main.js, but webcompoents dont bundle that file
Vue.config.productionTip = false

export default {
  mounted:function(){
    this.loadMap();
  },
  methods:{
    loadMap:function(){
      mapboxgl.accessToken =
        "pk.eyJ1Ijoic3BhdGlhbCIsImEiOiJINEMxWmw4In0.MXOfvjXYb65iOfIAKcRLbA"; //spatial token
      let bounds = [
        [-180, -90], // Southwest coordinates
        [180, 90], // Northeast coordinates
      ];

      let map = new mapboxgl.Map({
        container: this.$refs.mapContainer, // container id
        style: "mapbox://styles/spatial/ck9gb822i2nz41imwx0qj3pfr", //completely blank style
        center: [0, 35], // starting position [lng, lat]
        zoom: 0.6, // starting zoom
        maxBounds: bounds, //set bounds as max, stops going around the world
      });

      map.on("load", function () {
        map.resize();

        map.addSource("mean-raster-src", {
          type: "raster",
          url: "mapbox://spatial.7grefhas", //raster tileset
        });

        map.addLayer({
          id: "mean-raster",
          type: "raster",
          source: "mean-raster-src",
        });

        // draws the country boarders
        map.addLayer({
          id: "world-countries",
          type: "line",
          source: {
            type: "vector",
            url: "mapbox://spatial.czmo4e0k", //vector tileset
          },
          "source-layer": "level0_iso3_noantarctica",
        });
        //creates the clickable area for popup- labels
        map.addLayer({
          id: "loc-fills",
          type: "fill",
          source: {
            type: "vector",
            url: "mapbox://spatial.czmo4e0k", //vector tileset
          },
          "source-layer": "level0_iso3_noantarctica",
          paint: {
            "fill-opacity": 0,
          },
          layout: {},
        });

        //country labels displayed based on size of country and zoom level
        map.addLayer({
          id: "cnty-labels",
          type: "symbol",
          source: {
            type: "vector",
            url: "mapbox://spatial.dw5v2kzr", //centroid tileset
          },
          "source-layer": "levell0_iso3_noantarctica_lab-8r85mx",
          layout: {
            "text-field": "{country}",
            "text-variable-anchor": [
              "center",
              "top",
              "bottom",
              "left",
              "right",
            ],
            // "text-anchor":
            //   //special label placement for Peru
            //   [
            //     "case",
            //     ["==", ["get", "iso3"], "PER"],
            //     "bottom-right",
            //     "center",
            //   ],
            "text-justify": "center",
            "text-allow-overlap": false,
            "text-ignore-placement": false,
            "text-size": [
              "interpolate",
              ["exponential", 0.1],
              ["zoom"],
              1,
              ["case", [">", ["get", "_area"], 3000000000000], 10, 0],
              2,
              ["case", [">", ["get", "_area"], 2000000000000], 12, 0],
              3,
              ["case", [">", ["get", "_area"], 500000000000], 15, 0],
              4,
              ["case", [">", ["get", "_area"], 80000000000], 18, 0],
              5,
              ["case", [">", ["get", "_area"], 1000000000], 18, 0],
              6,
              ["case", [">", ["get", "_area"], 49400000], 18, 0],
              7,
              18,
            ],
            // "symbol-sort-key": [
            //   "to-number",
            //   ["case", [">", ["get", "_area"], 1000000000000], 2, 1],
            // ],
          },
        });
      }); ///end of map.on("load")

      // click functionality
      map.on("click", "loc-fills", function (e) {
        let lngLat = e.lngLat;
        let popUp = new mapboxgl.Popup()
          .setLngLat(lngLat)
          //.setHTML(e.features[0].properties.country)
          .setHTML(" ")
          .addTo(map);

        fetch(process.env.VUE_APP_API_URL + 'geo/pm25raster/' + lngLat.toArray().join())
          .then((response) => {
            if (!response.ok) {
              throw Error(response.statusText);
            }
            return response.json();
          })
          .then((data) => {
            popUp.setHTML("Value: " + data[0].rastervalue)
          })
          .catch((error) => {
            console.log(error);
            popUp.setHTML("An error occurred. Try again later.");
          });
      });

      // change mouse back to pointer when leaves countries
      map.on("mouseenter", "loc-fills", function () {
        map.getCanvas().style.cursor = "crosshair";
      });

      // change mouse back to pointer when leaves countries
      map.on("mouseleave", "loc-fills", function () {
        map.getCanvas().style.cursor = "";
      });

      // Add zoom controls and remove compass control
      map.addControl(
        new mapboxgl.NavigationControl({
          showCompass: false,
        })
      );

      // map.on("zoom", function () {
      //   console.log(map.getZoom());
      // });
    }
  }
}
</script>

<style src='mapbox-gl/dist/mapbox-gl.css'>
    /* global styles */
</style> 

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  body {
    margin: 0;
    padding: 0;
  }
  #map {
    position: absolute;
  }
  .shape {
    width:100%;
    height: 100%; 
  }
  :focus {
    outline: none;
  }

  .legend {
    background-color: #fff;
    border-radius: 3px;
    bottom: 30px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    font: 12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif;
    padding: 10px;
    position: absolute;
    right: 10px;
    z-index: 1;
    text-align: left;
  }
    
  .legend h4 {
    margin: 0 0 10px;
  }
    
  .legend div span {
    border-radius: 50%;
    display: inline-block;
    height: 10px;
    margin-right: 5px;
    width: 10px;
  }
</style>
